<mat-form-field class="cart-delivery-location-field">
  <mat-label>{{'CART.ADDRESS' | transloco}}</mat-label>
  <mat-icon matPrefix
  color="primary">pin_drop</mat-icon>
  <input matInput
    type="text"
    [formControl]="addressSearchControl"
    class="form-control"
    #search
    required>
  @if (control?.touched && (control?.hasError('required') || addressSearchControl.hasError('required'))) {
    <mat-error>
      {{ 'COMMON.ERRORS.FIELD_REQUIRED_FORMAT' | transloco : { field: ('CART.ADDRESS' | transloco) } }}
    </mat-error>
  }
  @if (control?.touched && control?.hasError('validateAddress')) {
    <mat-error>
      {{ 'TODO validateAddress' }}
    </mat-error>
  }
</mat-form-field>
